import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

import HardProductFields from './HardProductFields';
import SoftProductFields from './SoftProductFields';

export default function ResearchResult({ data }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  return (
    <div>
      <h4>{t('projectProposal.researchResult.viewLabel')}</h4>
      <h4>{t('projectProposal.researchResult.productAndResearchResultDes.label')}</h4>
      <SoftProductFields products={data?.softProducts} />
      <HardProductFields
        products={data?.hardProducts}
        qualityComparison={data?.qualityComparison}
      />
    </div>
  );
}

ResearchResult.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
};
